export default class RegisterViewModel {
  policyModal = {
    title: 'Política de privacidad',
  };
}
